import { createStore } from "vuex";
import liff from "@line/liff";
import axios from "axios";
import { nextTick } from "vue";
import VConsole from "vconsole";

if (process.env.NODE_ENV !== "production") {
	const vConsole = new VConsole({ theme: "dark" });
	console.log(vConsole);
}

export function createAppStore(config, router) {
	return createStore({
		strict: true,
		state: {
			isActiveLoading: true,
			userLineInfo: {},
			userNbInfo: {},
			selectedShopItem: null,
			selectedMyGiftItem: null,
			intendedRoute: null,
			isShopApp: config.isShopApp || false,
			liffID: config.liffID,
			baseUri: config.baseUri,
			hostUrl: config.hostUrl,
			migoBindLiffId: config.migoBindLiffId || null,
			migoLiffId: config.migoLiffId || null,
			isMaintenanceMode: process.env.VUE_APP_MAINTENANCE === 'true',
			showMaintenancePopup: false,
		},
		mutations: {
			loadingToggle(state, value) {
				state.isActiveLoading = value;
			},
			setUserLineInfo(state, { token, userId }) {
				state.userLineInfo.token = token;
				state.userLineInfo.userId = userId;
			},
			setUserNBInfo(state, data) {
				state.userNbInfo = data;
			},
			getUserNBInfo(state, data) {
				state.userNbInfo.data = data;
			},
			updateUserNBInfoUser(state, userData) {
				state.userNbInfo.data.user = { ...state.userNbInfo.data.user, ...userData };
			},
			setSelectedShopItem(state, item) {
				state.selectedShopItem = item;
			},
			setSelectedMyGiftItem(state, item) {
				state.selectedMyGiftItem = item;
			},
			setIntendedRoute(state, route) {
				state.intendedRoute = route;
			},
			setShowMaintenancePopup(state, value) {
				state.showMaintenancePopup = value;
			},
		},
		actions: {
			getDataFromCookie(context) {
				let cookieAry = document.cookie.split(";");
				let newCookiAry = [];
				cookieAry.forEach((element, index) => {
					newCookiAry[index] = element.trim();
				});
				let cookieStr = newCookiAry.filter(value => value.match(/^userNbInfo/g));

				if (cookieStr.length === 0) {
					context.dispatch("userLogin");
				} else {
					let data = JSON.parse(decodeURIComponent(cookieStr[0].split("=")[1].replace(/"/g, "")));
					context.commit("setUserNBInfo", data);
					if (!context.state.isShopApp) {
						nextTick(() => {
							context.commit("loadingToggle", false);
						});
					}
				}
			},
			userLogin(context) {
				axios
					.post(context.state.hostUrl + "auth/login", {
						idToken: context.state.userLineInfo.token,
						isFirst: router.currentRoute._value.path === "/",
					})
					.then(function (response) {
						if (response.status === 200) {
							let data = response.data;
							console.log('login');
							console.log(data);
							context.commit("setUserNBInfo", data);
							nextTick(() => {
								if (!context.state.isShopApp) {
									context.commit("loadingToggle", false);
								}
								if (context.state.intendedRoute) {
									const target = context.state.intendedRoute;
									context.commit("setIntendedRoute", null);
									router.push(target);
								}
							});
						}
					})
					.catch(function (error) {
						if (error.response.status === 401) {
							document.cookie = "LIFF_STORE:expires:" + context.state.liffID + "= ; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
							location.reload();
						}
						if (error.response.data.error === "40004") {
							alert('註冊發生異常，請洽門市人員協助。');
							location.href = 'https://maac.io/54JIy';
						}
						console.log(error);
					});
			},
			getUserNBInfo(context) {
				return axios
					.get(context.state.hostUrl + "auth/me", {
						headers: {
							Authorization: `Bearer ${context.state.userNbInfo.access_token}`,
							"Content-Type": "application/json",
						},
					})
					.then(function (response) {
						if (response.status === 200) {
							let data = response.data.data;
							context.commit("getUserNBInfo", data);
						}
					})
					.catch(function (error) {
						console.log(error);
					});
			},
			initLineLiff(context) {
				if (!context.state.liffID) {
					window.alert("LIFF ID error");
				} else {
					liff.init({
						liffId: context.state.liffID,
					})
						.then(function () {
							const bypass = sessionStorage.getItem('maintenanceBypass');
							if (context.state.isMaintenanceMode && bypass !== '1') {
								context.commit('loadingToggle', false);
								context.commit('setShowMaintenancePopup', true);
								return;
							}
							if (!liff.isLoggedIn()) {
								liff.login({
									redirectUri: context.state.baseUri,
								});
							} else {
								let token = liff.getIDToken();
								liff.getProfile().then(function (profile) {
									let userId = profile.userId;
									context.commit("setUserLineInfo", {
										token,
										userId,
									});
									context.dispatch("getDataFromCookie");

									window.dataLayer = window.dataLayer || [];
									window.dataLayer.push({
										event: "uid_loaded",
										uid: userId,
									});
								});
							}
						})
						.catch(function (error) {
							console.log(error);
						});
				}
			},
		},
		modules: {},
	});
}
